export type PanelVariant = 'detail' | 'aux';

/**
 * Geometry and ground per panel, from the design. The detail panel sits on the tinted surface that
 * marks it as the selected order and keeps that ground when it becomes an overlay; the aux panel
 * stays white and narrower beside the board.
 */
const VARIANTS = {
  detail: {
    ground: 'bg-purple-lightest',
    dockedWidth: 360,
    dockedTop: 'mt-0.5',
    overlayWidth: 360,
    overlayMaxWidth: '88%',
    overlayEdge: '',
  },
  aux: {
    ground: 'bg-brand-white',
    dockedWidth: 248,
    dockedTop: 'mt-2',
    overlayWidth: 300,
    overlayMaxWidth: '86%',
    overlayEdge: 'border-l border-grey-medium',
  },
} as const;

type Props = {
  variant: PanelVariant;
  docked: boolean;
  children: React.ReactNode;
};

/**
 * Shared shell for the right-side panels: a detached card docked next to the
 * board on desktop, a slide-in overlay on smaller screens.
 */
const SidePanel = ({ variant, docked, children }: Props) => {
  const spec = VARIANTS[variant];

  if (docked) {
    return (
      <aside
        className={`flex-none flex flex-col min-h-0 rounded mr-4 mb-4 ${spec.dockedTop} ${spec.ground}`}
        style={{ width: spec.dockedWidth }}
      >
        {children}
      </aside>
    );
  }

  return (
    <aside
      className={`kds-panel-in absolute top-0 right-0 bottom-0 z-50 flex flex-col min-h-0 shadow-dialog ${spec.ground} ${spec.overlayEdge}`}
      style={{ width: spec.overlayWidth, maxWidth: spec.overlayMaxWidth }}
    >
      {children}
    </aside>
  );
};

export default SidePanel;
